export class DashboardData {
  ordersSummary: OrdersSummaryCnt[] = [];
  totalBalDept: number = 0;
  unreadMsgByMeCnt: number = 0;
  unreadMsgClinicToMeCnt: number = 0;
  unreadMsgPlantToMeCnt: number = 0;
  unreadMsgFromMeCnt: number = 0;
  unreadPlantMgrCnt: number = 0;
  dueDateUpdatesCnt: number = 0;
  allMsgCnt: number = 0;
  openDeliveryOrdersCnt: number = 0;
  openSuppliesOrdersCnt: number = 0;
  closedDeliveryOrdersCnt: number = 0;
  closedSuppliesOrdersCnt: number = 0;
  openDeliveryOrderDate: Date;
  openSuppliesOrderDate: Date;
  banners: Banner[] = [];
  news: News[] = [];
  myTasksCnt: number = 0;
  allOpenTasksCnt: number = 0;
  allClosedTasksCnt: number = 0;
  lateTasksCnt: number = 0;
  pendingPresetNotesCnt?: number = 0;
  generalTasksCnt?: number = 0;
  clinicDelayAlertCnt?: number = 0;

  constructor() {}
}

export class OrdersSummaryCnt {
  summaryCode: string;
  descr: string;
  cnt: number;
  constructor() {}
}

export class DashboardContent {
  contentId: number;
  updDate: Date;
  sortOrder: number;
  validUntilDate: Date;
}

export class Banner extends DashboardContent {
  imgUrl: string;
  linkUrl: string;

  constructor() {
    super();
  }
}

export class News extends DashboardContent {
  text: string;

  constructor() {
    super();
  }
}
